import { Fab, Tooltip } from "@material-ui/core";
import * as React from "react";

import { Button, SaveIcon, TextArea, useDeviceSize } from "../../../";
import { useNoteComposerStyles } from "./notes.styles";

interface Props {
    context?: string;
    baseId: string;

    onSend: (note: string) => void;
    onSetNoteDirty?: (isDirty: boolean) => void;
}

export const NoteComposer = React.memo((props: Props) => {
    const { baseId, context, onSetNoteDirty, onSend } = props;

    const extendedId = `${baseId}NoteComposer`;

    const classes = useNoteComposerStyles({});
    const [note, setNote] = React.useState("");
    const [isDirty, setIsDirty] = React.useState(false);

    const device = useDeviceSize();

    React.useEffect(() => {
        setNote("");
    }, [context]);

    React.useEffect(() => {
        const trimmedNote = note.trim();
        setIsDirty(trimmedNote.length > 0);
    }, [note]);

    React.useEffect(() => {
        onSetNoteDirty && onSetNoteDirty(isDirty);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDirty]);

    const handleClick = React.useCallback(() => {
        onSend(note.trim());
        setNote("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [note]);

    return (
        <div className={classes.root} id={`${extendedId}Container`}>
            <TextArea
                id={`${extendedId}TextArea`}
                className={classes.entry}
                value={note}
                placeholder="type note here"
                rows={6}
                fullWidth
                multiline
                showCharacterLimit
                characterLimitSide="left"
                onChange={e => setNote(e.target.value)}
                inputProps={{ maxLength: 500 }}
            />
            {device === "desktop" ? (
                <div className={classes.button}>
                    <Tooltip
                        title={`add note ${context ? "to " + context : ""}`}
                    >
                        <span>
                            <Fab
                                id={`${extendedId}Button`}
                                onClick={handleClick}
                                disabled={!isDirty}
                                size="small"
                                color="primary"
                            >
                                <SaveIcon />
                            </Fab>
                        </span>
                    </Tooltip>
                </div>
            ) : (
                <div>
                    <span>
                        <Button
                            className={classes.mobileButton}
                            id={`${extendedId}Button`}
                            onClick={handleClick}
                            disabled={!isDirty}
                            color="primary"
                        >
                            add notes
                        </Button>
                    </span>
                </div>
            )}
        </div>
    );
});
